import { Component } from '@angular/core'

@Component({
  selector: 'ftr-supported-browsers',
  templateUrl: './supported-browsers.component.html',
  styleUrls: ['./supported-browsers.component.css'],
})
export class SupportedBrowsersComponent {}
